import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import '../style/home.css';
import axios from "axios";
import CryptoJS from "crypto-js";
import BottomBar from "./BottomBar";

class Wallet extends React.Component {

    constructor() {
        super();
        this.state = {
            type: "",
            wallet: "",
            showLoading: "block",
            history:[]
        }
    }

    componentDidMount() {


        var form = new FormData();
        form.append("session", localStorage.getItem("token"));
        form.append("mobile", localStorage.getItem("mobile"));

        var encrypted = CryptoJS.AES.encrypt(process.env.REACT_APP_URL+"/api2/games.php", window.location.href);
        console.log(encrypted.toString())

        // U2FsdGVkX18g6/vuGGV2r1UDOGrc7wYOZIgXrjnmIackUXF6oOymMDsvpuTz8NIAqSLB3PpMko6sPYI/axYWPA==

        axios
            .post(process.env.REACT_APP_URL+"/api2/games.php", form,
            )
            .then((response) => {
                this.setState({
                    showLoading:"none",
                })
                console.log(response.data)
                if(response.status === 200){
                    localStorage.setItem("wallet", response.data.wallet)
                    this.setState({
                        showLoading:"none",
                        history:response.data.data
                    })
                } else if(response.status === 401){
                    //  navigate("/login")
                }
            })
    }


    render() {


        
        let getGameName = (e) => {
            if(e.endsWith("_A")){
                return "ANDAR"
            } else if(e.endsWith("_B")){
                return "BAHAR"
            } else {
                return "JODI";
            }
        }
    
        return (<>
                <div className="RootView">
                    <div className="RootWidth">

                    <div style={{display:this.state.showLoading}}>
                        <div class="loader-parent">
                        <div class="loader-block">
                        <div class="loader"></div> 
                        </div>
                        </div>
                    </div>
                    

                        <div className="loginDiv">


                            <div className="toolbar">
                                <div>
                                    <img onClick={()=>{window.history.go(-1)}}  src="../images/back.png" style={{padding: "5px"}}/>
                                    <span>Game History</span>
                                </div>


                            </div>

                            <div style={{padding:"15px", marginBottom:"70px"}}>

                                { this.state.history && this.state.history.map((result) => {
                                    return (
                                        <div className="transaction_block borderdiv" style={{marginBottom:"10px"}} key={result.sn}>
                                            <div className="date-blocks" style={{fontSize:"16px", color:"white", paddingLeft:"10px", paddingRight:"10px", display: "flex",
    justifyContent: "space-between",
    alignItems:"center"}}>
                                                <span>{result.bazar.replace("_BA"," BA").replace("_A"," ").replace("_B"," ").replace("_"," ")}</span>
                                                <span style={{fontSize:"12px"}}>{result.date}</span>
                                                
                                                </div>
                                            <div style={{padding:"0px"}}>
                                                <div className="game-sections">
                                                    <span className="title">Game Type</span>
                                                    
                                                    <span className="data">
                                                    { getGameName(result.bazar) }
                                                        </span>
                                                </div>
                                                <div className="game-sections">
                                                    <span className="title">Digit</span>
                                                    <span className="data">{result.number}</span>
                                                </div>
                                                <div className="game-sections">
                                                    <span className="title">Point</span>
                                                    <span className="data">{result.amount}</span>
                                                </div>
                                            </div>
                                            
                                            
                                        </div>
                                    )})}


                            </div>

                        </div>


                    </div>
                </div>

                <BottomBar />


            </>
        );
    }

}

export default Wallet;
